import { useFilledDisclosuresListColumns } from './useFilledDisclosuresListColumns';
import { useFilledDisclosuresListPage } from './useFilledDisclosuresListPage';

import { IconManager } from '@speeki/icons';

import {
    ContainerInner,
    ContainerSection,
} from '@components/_global/GlobalStyle/Global.styled';
import { Container } from '@components/ions/layouts';
import { List } from '@components/organisms/List/List';
import { DefaultLayout } from '@components/templates/DefaultLayout/DefaultLayout';

import IconDisclosuresEmpty from '@shared/svgs/IconDisclosuresEmpty.svg';

import {
    AnswerDisclosure,
    HeaderWrapper,
    Title,
} from './FilledDisclosuresListPage.styled';

export const FilledDisclosuresListPage = () => {
    const { columns } = useFilledDisclosuresListColumns();
    const {
        disclosureDetails,
        disclosureList,
        isLoading,
        openPersonalInfoModal,
        openSubmission,
        pagination,
        t,
    } = useFilledDisclosuresListPage();

    return (
        <DefaultLayout contentPadding={{ bottom: 40 }}>
            <Container>
                <ContainerInner>
                    <ContainerSection>
                        <HeaderWrapper>
                            <Title>{disclosureDetails?.name}</Title>
                            {disclosureDetails?.canAnswer && (
                                <AnswerDisclosure
                                    onClick={openPersonalInfoModal}
                                >
                                    <IconManager
                                        icon="SvgAddForm24"
                                        size={24}
                                        themeColors={{
                                            default: {
                                                'color-1': 'secondary.default',
                                            },
                                        }}
                                    />
                                </AnswerDisclosure>
                            )}
                        </HeaderWrapper>
                        <List
                            columns={columns}
                            emptyListProps={{
                                description: t('NO_ACTIVE_DISCLOSURES_INFO'),
                                icon: IconDisclosuresEmpty,
                                title: t('NO_ACTIVE_DISCLOSURES'),
                            }}
                            isLoading={isLoading}
                            isSearch={false}
                            list={disclosureList}
                            onRowClick={openSubmission}
                            pagination={pagination}
                            testId="3xVZl5t"
                        />
                    </ContainerSection>
                </ContainerInner>
            </Container>
        </DefaultLayout>
    );
};
